import * as max from '../max-length-validators';
import * as required from '../required-validators';

export default {
  name: 'townCity',
  label: 'checkout.delivery.address.field.label.town.text',
  required: true,
  maxLength: 35,
  validate: [required.townCity, max.lengthAddress(35)],
};
